import MapSwitcher from "./MapSwitcher";

export default MapSwitcher;
